import React from 'react';
import {observer} from 'mobx-react';
import {CompetitionGamesViewModel} from "../models/competition-games-view-model";
import {
  ScoresListWidgetCompetitionInfo,
  ScoresListWidgetCompetitionInfoProps
} from "./competition/scores-list-widget.competition.info";
import {ScoresListWidgetProps} from "../models/scores-list-widget.props";

export const ScoresListWidgetCompetitions = observer((props: ScoresListWidgetProps) => {
  const scoresListWidgetCompetitionInfoProps: Array<ScoresListWidgetCompetitionInfoProps> = props.controller.state.gamesByCompetition.map((competition: CompetitionGamesViewModel, index: Number) => {
    // const shouldRenderAd = props.controller.state.adsIndexes.includes(index);

    return {
      ...props,
      // shouldRenderAd,
      index,
      competition,
      forceRender: index < props.controller.state.competitionsLimit,
    };
  });

  return (
    <div className={'scores-list-widget-competitions'}>
      {
        scoresListWidgetCompetitionInfoProps.map((competitionProps: ScoresListWidgetCompetitionInfoProps) => <ScoresListWidgetCompetitionInfo {...competitionProps}/>)
      }
    </div>
  )
});
